import { api } from './api-util/api';

export class EventsApi {
  async getFailedIngestions(orgId: string): Promise<any[]> {
    return await api().get(`/events/failed-ingestions/${orgId}`);
  }
}
